import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    BooleanInput,
    required,
} from 'react-admin';
import { RichTextInput } from '../../components/RichTextInput';

const req = [required()];

const EntityCreate = () => {
    return (
        <>
            {/* @ts-ignore */}
            <Create>
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <TextInput
                        source="title"
                        isRequired
                        validate={req}
                        fullWidth
                    />
                    <BooleanInput source="active" fullWidth />
                    <TextInput source="element" fullWidth />
                    <TextInput source="slug" fullWidth />
                    <TextInput source="link" fullWidth />
                    <RichTextInput source="content" fullWidth />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
